import React, { useEffect, useState } from 'react';
import global from 'global';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import { toast } from 'react-toastify';

import request from 'request';
import Button from 'components/button';
import Input from 'components/input';
import ResultBox from 'components/result-box';
import { useDispatch, useSelector } from 'store/hooks';
import prettierNumber from 'utils/prettier-number';
import { stopFactorStatusTranscript } from 'utils/prettier-status';
import isDateNotInFuture from 'utils/is-data-is-not-in-future';
import transcript from 'utils/transcript';
import styles from './scoring.module.scss';
import { title } from 'process';
import { isNull } from 'mathjs';

let timeout: NodeJS.Timeout;
const Scoring = () => {
	const { id } = useParams();
	const application = useSelector((state) => state.application);
	const dispatch = useDispatch();
	const [macrodata, setMacrodata] = React.useState<global.macrodata>();
	const [pending, setPending] = React.useState(false);
	const [formValid, setFormValid] = React.useState(false);

	const [form, setForm] = useState({
		age: String(application.data?.scoring_log?.age ?? ''),
		dependents: String(application.data?.scoring_log?.dependants ?? ''),
		address: String(application.data?.scoring_log?.address ?? ''),
		postpone_payments: String(application.data?.scoring_log?.postpone_payments ?? ''),
		max_days_late_payments: String(application.data?.scoring_log?.max_days_late_payments ?? ''),
		project_net_monthly_income: String(
			application.data?.scoring_log?.project_net_monthly_income ?? ''
		),
		additional_income: String(application.data?.scoring_log?.additional_income ?? ''),
		monthly_payment_for_active_loans: String(
			application.data?.scoring_log?.monthly_payment_for_active_loans ?? ''
		),
		guarantor_age: String(application.data?.scoring_log?.guarantor_age ?? ''),
		guarantor_income: String(application.data?.scoring_log?.guarantor_income ?? ''),
		guarantor_additional_income: String(
			application.data?.scoring_log?.guarantor_additional_income ?? ''
		),
		guarantor_total_monthly_payments: String(
			application.data?.scoring_log?.guarantor_total_monthly_payments ?? ''
		),
		date_of_early_settlements_loan: !application.data?.scoring_log?.date_of_early_settlements_loan
			? ''
			: String(
					application.data?.scoring_log?.date_of_early_settlements_loan
						.split('-')
						.reverse()
						.join('/')
			  ),
		longest_payment_delay_by_guarantor: String(
			application.data?.scoring_log?.longest_payment_delay_by_guarantor ?? ''
		),
		number_of_active_upcoming_payments: String(
			application.data?.scoring_log?.number_of_active_upcoming_payments ?? ''
		),
		work_experience: String(application.data?.scoring_log?.work_experience ?? ''),
		transport_manufacturing_year: String(
			application.data?.scoring_log?.transport_manufacturing_year ?? ''
		),
		branch: {
			key: String(application.data?.scoring_log?.branch ?? ''),
			value: transcript.branch.getValueFromKey(String(application.data?.scoring_log?.branch)),
		},
		loan_purpose: {
			key:
				application.data?.scoring_log?.loan_purpose === null ||
				application.data?.scoring_log?.loan_purpose === undefined
					? ''
					: application.data?.scoring_log?.loan_purpose
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.loan_purpose === null ||
				application.data?.scoring_log?.loan_purpose === undefined
					? ''
					: application.data?.scoring_log?.loan_purpose
					? 'Yes'
					: 'No',
		},
		nationality: {
			key: String(application.data?.scoring_log?.nationality ?? ''),
			value: String(application.data?.scoring_log?.nationality ?? ''),
		},
		client_has_early_settlement_loan: {
			key: String(application.data?.scoring_log?.client_has_early_settlement_loan ?? ''),
			value: String(application.data?.scoring_log?.client_has_early_settlement_loan ?? ''),
		},
		dual_loans: {
			key:
				application.data?.scoring_log?.dual_loans === null ||
				application.data?.scoring_log?.dual_loans === undefined
					? ''
					: application.data?.scoring_log?.dual_loans
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.dual_loans === null ||
				application.data?.scoring_log?.dual_loans === undefined
					? ''
					: application.data?.scoring_log?.dual_loans
					? 'Yes'
					: 'No',
		},
		client_status_gurantor: {
			key:
				application.data?.scoring_log?.client_status_gurantor === null ||
				application.data?.scoring_log?.client_status_gurantor === undefined
					? ''
					: application.data?.scoring_log?.client_status_gurantor
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.client_status_gurantor === null ||
				application.data?.scoring_log?.client_status_gurantor === undefined
					? ''
					: application.data?.scoring_log?.client_status_gurantor
					? 'Yes'
					: 'No',
		},
		family_members_delinquent: {
			key:
				application.data?.scoring_log?.family_members_delinquent === null ||
				application.data?.scoring_log?.family_members_delinquent === undefined
					? ''
					: application.data?.scoring_log?.family_members_delinquent
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.family_members_delinquent === null ||
				application.data?.scoring_log?.family_members_delinquent === undefined
					? ''
					: application.data?.scoring_log?.family_members_delinquent
					? 'Yes'
					: 'No',
		},
		guarantor_has_active_loan: {
			key:
				application.data?.scoring_log?.guarantor_has_active_loan === null ||
				application.data?.scoring_log?.guarantor_has_active_loan === undefined
					? ''
					: application.data?.scoring_log?.guarantor_has_active_loan
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.guarantor_has_active_loan === null ||
				application.data?.scoring_log?.guarantor_has_active_loan === undefined
					? ''
					: application.data?.scoring_log?.guarantor_has_active_loan
					? 'Yes'
					: 'No',
		},
		guarantor_for_another_loan: {
			key:
				application.data?.scoring_log?.guarantor_for_another_loan === null ||
				application.data?.scoring_log?.guarantor_for_another_loan === undefined
					? ''
					: application.data?.scoring_log?.guarantor_for_another_loan
					? '1'
					: '0',
			value:
				application.data?.scoring_log?.guarantor_for_another_loan === null ||
				application.data?.scoring_log?.guarantor_for_another_loan === undefined
					? ''
					: application.data?.scoring_log?.guarantor_for_another_loan
					? 'Yes'
					: 'No',
		},
		gender: {
			key: String(application.data?.scoring_log?.gender ?? ''),
			value: transcript.genderСode.getValueFromKey(String(application.data?.scoring_log?.gender)),
		},
		city: {
			key: String(application.data?.scoring_log?.city ?? ''),
			value: transcript.city.getValueFromKey(String(application.data?.scoring_log?.city)),
		},
		family_status: {
			key: String(application.data?.scoring_log?.family_status ?? ''),
			value: transcript.familyStatusEng.getValueFromKey(
				String(application.data?.scoring_log?.family_status)
			),
		},
		phoneOS: {
			key: String(application.data?.scoring_log?.phone_os ?? ''),
			value: String(application.data?.scoring_log?.phone_os ?? ''),
		},
		active_loan_with_same_family_id: {
			key: String(application.data?.scoring_log?.active_loan_with_same_family_id ?? ''),
			value: String(application.data?.scoring_log?.active_loan_with_same_family_id ?? ''),
		},
		transport: {
			key: String(application.data?.scoring_log?.transport ?? ''),
			value: String(application.data?.scoring_log?.transport ?? ''),
		},
		residence_type: {
			key: String(application.data?.scoring_log?.residence_type ?? ''),
			value: String(application.data?.scoring_log?.residence_type ?? ''),
		},
		employment_level: {
			key: String(application.data?.scoring_log?.employment_level ?? ''),
			value: String(application.data?.scoring_log?.employment_level ?? ''),
		},
		employment_status: {
			key: String(application.data?.scoring_log?.employment_status ?? ''),
			value: String(application.data?.scoring_log?.employment_status ?? ''),
		},
		guarantors: application.data?.guarantor_log.length
			? application.data.guarantor_log.map((g) => ({
					guarantor_age: String(g.guarantor_age),
					guarantor_for_another_loan: {
						key: String(g.guarantor_for_another_loan),
						value: String(g.guarantor_for_another_loan),
					},
					guarantor_has_active_loan: {
						key: String(g.guarantor_has_active_loan),
						value: String(g.guarantor_has_active_loan),
					},
					guarantor_income: String(g.guarantor_income),
					guarantor_additional_income: String(g.guarantor_additional_income),
					longest_payment_delay_by_guarantor: String(g.longest_payment_delay_by_guarantor),
					guarantor_total_monthly_payments: String(g.guarantor_total_monthly_payments),
					guarantor_nationality: {
						key: String(g.guarantor_nationality),
						value: String(g.guarantor_nationality),
					},
			  }))
			: Array.from({ length: application.data?.number_of_guarantors || 0 }, () => ({
					guarantor_age: '',
					guarantor_for_another_loan: {
						key: '',
						value: '',
					},
					guarantor_has_active_loan: {
						key: '',
						value: '',
					},
					guarantor_income: '',
					guarantor_additional_income: '',
					longest_payment_delay_by_guarantor: '',
					guarantor_total_monthly_payments: '',
					guarantor_nationality: {
						key: '',
						value: '',
					},
			  })),
	});

	

	const sendScoringRequest = async () => {
		return request.post(`/applications/${id}/scoring`, {
			scoring_data: {
				dependants: Number(form.dependents),
				family_status: form.family_status.key,
				gender: form.gender.key,
				age: Number(form.age),
				city: form.city.key,
				monthly_income: Number(form.project_net_monthly_income) + Number(form.additional_income),
			},
			collected_data: {
				branch: form.branch.key,
				phone_os: form.phoneOS.key,
				transport: form.transport.key,
				residence_type: form.residence_type.key,
				employment_level: form.employment_level.key,
				employment_status: form.employment_status.key,
				work_experience: Number(form.work_experience),
				transport_manufacturing_year: Number(form.transport_manufacturing_year),
				nationality: form.nationality.key,
				address: form.address,
				postpone_payments: Number(form.postpone_payments),
				project_net_monthly_income: Number(form.project_net_monthly_income),
				additional_income: Number(form.additional_income),
				monthly_payment_for_active_loans: Number(form.monthly_payment_for_active_loans),
				guarantor_income: form.guarantor_income === '' ? null : Number(form.guarantor_income),
				guarantor_additional_income:
					form.guarantor_additional_income === '' ? null : Number(form.guarantor_additional_income),
				client_has_early_settlement_loan: form.client_has_early_settlement_loan.key,
				guarantor_total_monthly_payments:
					form.guarantor_total_monthly_payments === ''
						? null
						: Number(form.guarantor_total_monthly_payments),
			},
			stop_factors: {
				group_loan: false,
				loan_purpose: form.loan_purpose.key === '' ? null : Boolean(Number(form.loan_purpose.key)),
				dual_loans: form.dual_loans.key === '' ? null : Boolean(Number(form.dual_loans.key)),
				max_days_late_payments:
					form.max_days_late_payments === '' ? null : Number(form.max_days_late_payments),
				client_status_gurantor:
					form.client_status_gurantor.key === ''
						? null
						: Boolean(Number(form.client_status_gurantor.key)),
				family_members_delinquent:
					form.family_members_delinquent.key === ''
						? null
						: Boolean(Number(form.family_members_delinquent.key)),
				active_loan_with_same_family_id:
					form.active_loan_with_same_family_id.key === ''
						? null
						: form.active_loan_with_same_family_id.key,
				guarantor_age: form.guarantor_age === '' ? null : Number(form.guarantor_age),
				guarantor_has_active_loan:
					form.guarantor_has_active_loan.key === ''
						? null
						: Boolean(Number(form.guarantor_has_active_loan.key)),
				guarantor_for_another_loan:
					form.guarantor_for_another_loan.key === ''
						? null
						: Boolean(Number(form.guarantor_for_another_loan.key)),
				date_of_early_settlements_loan:
					form.client_has_early_settlement_loan.value === 'No' ||
					form.date_of_early_settlements_loan === ''
						? null
						: form.date_of_early_settlements_loan.split('/').reverse().join('-'),
				longest_payment_delay_by_guarantor:
					form.longest_payment_delay_by_guarantor === ''
						? null
						: Number(form.longest_payment_delay_by_guarantor),
				number_of_active_upcoming_payments:
					form.number_of_active_upcoming_payments === ''
						? null
						: Number(form.number_of_active_upcoming_payments),
			},
			guarantor_data: form.guarantors.map((guarantor) => ({
				guarantor_age: guarantor.guarantor_age === '' ? null : Number(guarantor.guarantor_age),
				guarantor_for_another_loan:
					guarantor.guarantor_for_another_loan.key === ''
						? null
						: guarantor.guarantor_for_another_loan.key === 'true',
				guarantor_has_active_loan:
					guarantor.guarantor_has_active_loan.key === ''
						? null
						: guarantor.guarantor_has_active_loan.key === 'true',
				guarantor_income:
					guarantor.guarantor_income === '' ? null : Number(guarantor.guarantor_income),
				guarantor_additional_income:
					guarantor.guarantor_additional_income === ''
						? null
						: Number(guarantor.guarantor_additional_income),
				longest_payment_delay_by_guarantor:
					guarantor.longest_payment_delay_by_guarantor === ''
						? null
						: Number(guarantor.longest_payment_delay_by_guarantor),
				guarantor_total_monthly_payments:
					guarantor.guarantor_total_monthly_payments === ''
						? null
						: Number(guarantor.guarantor_total_monthly_payments),
				guarantor_nationality:
					guarantor.guarantor_nationality.key === '' ? null : guarantor.guarantor_nationality.key,
			})),
		});
	};

	const handleCalculate = async () => {
		let timeout: NodeJS.Timeout;
		setPending(true);
		sendScoringRequest()
			.then((res) => res.data)
			.then(async () => {
				timeout = setTimeout(() => dispatch.application.FETCH_APPLICATION_BY_ID({ id }), 1000);
			})
			.catch((e) => toast.error(JSON.stringify(e.response?.data?.detail?.[0])))
			.finally(() => setPending(false));
		return () => clearTimeout(timeout);
	};

	const handleChangeForm = (key: keyof typeof form, value: (typeof form)[keyof typeof form]) => {
	

		let newForm = { ...form, [key]: value };

		if (
			newForm.employment_status.key === 'None' ||
			newForm.employment_status.key === 'Unemployed'
		) {
			newForm = {
				...newForm,
				employment_level: {
					value: 'None',
					key: 'None',
				},
				work_experience: '0',
			};
		}

		if (key === 'client_has_early_settlement_loan') {
			newForm['date_of_early_settlements_loan'] = '';
		}

		setForm(newForm);

	};

	React.useEffect(() => {
		const formValid =
			form.age.trim() !== '' &&
			form.dependents.trim() !== '' &&
			form.address.trim() !== '' &&
			form.postpone_payments.trim() !== '' &&
			form.branch.key.trim() !== '' &&
			form.loan_purpose.key.trim() !== '' &&
			form.nationality.key.trim() !== '' &&
			form.max_days_late_payments.trim() !== '' &&
			form.project_net_monthly_income.trim() !== '' &&
			form.additional_income.trim() !== '' &&
			form.monthly_payment_for_active_loans.trim() !== '' &&
			(form.client_has_early_settlement_loan.value.trim() === 'No' ||
				!isDateNotInFuture(form.date_of_early_settlements_loan.trim())) &&
			(form.client_has_early_settlement_loan.value.trim() === 'No' ||
				form.date_of_early_settlements_loan.trim() !== '') &&
			form.client_has_early_settlement_loan.key.trim() !== '' &&
			form.dual_loans.key.trim() !== '' &&
			form.client_status_gurantor.key.trim() !== '' &&
			form.family_members_delinquent.key.trim() !== '' &&
			form.active_loan_with_same_family_id.key.trim() !== '' &&
			form.gender.key.trim() !== '' &&
			form.city.key.trim() !== '' &&
			form.family_status.key.trim() !== '' &&
			form.phoneOS.key.trim() !== '' &&
			form.transport.key.trim() !== '' &&
			form.residence_type.key.trim() !== '' &&
			form.employment_level.key.trim() !== '' &&
			form.employment_status.key.trim() !== '' &&
			form.work_experience.trim() !== '' &&
			form.transport_manufacturing_year.trim() !== '' &&
			form.guarantors.every((guarantor) => {
				return (
					guarantor.guarantor_age.trim() !== '' &&
					guarantor.guarantor_for_another_loan.key.trim() !== '' &&
					guarantor.guarantor_has_active_loan.key.trim() !== '' &&
					guarantor.guarantor_income.trim() !== '' &&
					guarantor.guarantor_additional_income.trim() !== '' &&
					guarantor.longest_payment_delay_by_guarantor.trim() !== '' &&
					guarantor.guarantor_total_monthly_payments.trim() !== '' &&
					guarantor.guarantor_nationality.key.trim() !== ''
				);
			});

		setFormValid(formValid);
	}, [application.data?.repeated_client, form]);

	React.useEffect(() => {
		if (application.data?.repeated_client === 'new') {
			setForm((prev) => ({
				...prev,
				postpone_payments: prev.postpone_payments === '' ? '0' : prev.postpone_payments,
				work_experience: prev.work_experience === '' ? '0' : prev.work_experience,
			}));
		}
		setForm((prev) => ({
			...prev,
			number_of_active_upcoming_payments:
				application.data?.repeated_client === 'new' ? '0' : prev.number_of_active_upcoming_payments,
		}));
	}, [application.data?.repeated_client]);

	React.useEffect(() => {
		request
			.get('/admin/constant_values')
			.then((res) => res.data)
			.then((d) => setMacrodata(d));
	}, []);

	const rowStopFactor = ({
		title,
		value,
		status,
	}: {
		title: string;
		value: string | number | null | undefined;
		status: 'approved' | 'rejected' | 'review' | 'no_status' | null | undefined;
	}) => {
		const statusClass =
			status === 'approved' || status === null
				? styles.green
				: status === 'review'
				? styles.yellow
				: styles.red;
		return (
			<div className={styles.row}>
				<div className={styles.col}>{title}</div>
				<div className={styles.col}>{value}</div>
				<div className={classNames(styles.col, statusClass)}>
					{status !== 'no_status' && stopFactorStatusTranscript(status)}
				</div>
			</div>
		);
	};

	return (
		<form className={styles.home}>
			<div className={styles.fields}>
				<div className={styles.creditDataBox}>
					<div className={styles.title}>Credit data</div>
					<div className={styles.list}>
						<div className={styles.item}>
							<div className={styles.key}>Amount</div>
							<div className={styles.value}>
								{prettierNumber(application.data?.amount ?? 0)} JOD
							</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Duration</div>
							<div className={styles.value}>{application.data?.duration} mon.</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Interest rate (annual)</div>
							<div className={styles.value}>
								{(Number(application.data?.interest_rate) * 100).toFixed(2)} %
							</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Number of guarantors</div>
							<div className={styles.value}>{application.data?.number_of_guarantors}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Number of payments</div>
							<div className={styles.value}>{application.data?.number_of_payments}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Loan duration of current loan</div>
							<div className={styles.value}>{application.data?.loan_duration_of_current_loan}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Prior loans</div>
							<div className={styles.value}>{application.data?.prior_loans}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Active loans</div>
							<div className={styles.value}>{application.data?.active_loans_credit_cards}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Repeated client?</div>
							<div className={styles.value}>{application.data?.repeated_client}</div>
						</div>
						<div className={styles.item}>
							<div className={styles.key}>Threshold</div>
							<div className={styles.value}>
								{application.data?.scoring_log?.threshold
									? (application.data?.scoring_log?.threshold * 100).toFixed()
									: Math.round((macrodata?.threshold ?? 0) * 100)}{' '}
								%
							</div>
						</div>
					</div>
				</div>
				{!!application.data?.scoring_log?.is_approved && (
					<>
						<div className={styles.creditDataBox}>
							<div className={styles.title}>Client data</div>
							<div className={styles.list}>
								<div className={styles.item}>
									<div className={styles.key}>Gender</div>
									<div className={styles.value}>
										{transcript.genderСode.getValueFromKey(application.data.scoring_log.gender)}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Family status</div>
									<div className={styles.value}>
										{transcript.familyStatusEng.getValueFromKey(
											application.data.scoring_log.family_status
										)}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Dependants</div>
									<div className={styles.value}>{application.data.scoring_log.dependants}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Client residence</div>
									<div className={styles.value}>
										{transcript.city.getValueFromKey(application.data.scoring_log.city)}
									</div>
								</div>
							</div>
						</div>
						<div className={styles.creditDataBox}>
							<div className={styles.title}>Alternative data</div>
							<div className={styles.list}>
								<div className={styles.item}>
									<div className={styles.key}>Transport manufacturing year</div>
									<div className={styles.value}>
										{application.data.scoring_log.transport_manufacturing_year}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Transport</div>
									<div className={styles.value}>{application.data.scoring_log.transport}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Employment status</div>
									<div className={styles.value}>
										{application.data.scoring_log.employment_status}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Employment level</div>
									<div className={styles.value}>
										{application.data.scoring_log.employment_level}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Residence type</div>
									<div className={styles.value}>{application.data.scoring_log.residence_type}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Work experience</div>
									<div className={styles.value}>{application.data.scoring_log.work_experience}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Phone OS</div>
									<div className={styles.value}>{application.data.scoring_log.phone_os}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Branch</div>
									<div className={styles.value}>
										{transcript.branch.getValueFromKey(application.data.scoring_log.branch)}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Nationality</div>
									<div className={styles.value}>{application.data.scoring_log.nationality}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Address</div>
									<div className={styles.value}>{application.data.scoring_log.address}</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Postponed payments/installments</div>
									<div className={styles.value}>
										{application.data.scoring_log.postpone_payments}
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Project net monthly income</div>
									<div className={styles.value}>
										{application.data.scoring_log.project_net_monthly_income} JOD
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Additional income</div>
									<div className={styles.value}>
										{application.data.scoring_log.additional_income} JOD
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>
										Client monthly payment for active loans (non-AMC)
									</div>
									<div className={styles.value}>
										{application.data.scoring_log.monthly_payment_for_active_loans} JOD
									</div>
								</div>
								<div className={styles.item}>
									<div className={styles.key}>Monthly payment</div>
									<div className={styles.value}>
										{application.data.scoring_log.monthly_payment?.toFixed(1)} JOD
									</div>
								</div>
								{application.data.scoring_log.guarantor_income !== null && (
									<div className={styles.item}>
										<div className={styles.key}>Guarantor income</div>
										<div className={styles.value}>
											{application.data.scoring_log.guarantor_income} JOD
										</div>
									</div>
								)}
								{application.data.scoring_log.guarantor_total_monthly_payments !== null && (
									<div className={styles.item}>
										<div className={styles.key}>
											Guarantor monthly payment for active loans (non-AMC)
										</div>
										<div className={styles.value}>
											{application.data.scoring_log.guarantor_total_monthly_payments} JOD
										</div>
									</div>
								)}
								{application.data.scoring_log.guarantor_additional_income !== null && (
									<div className={styles.item}>
										<div className={styles.key}>Guarantor additional income</div>
										<div className={styles.value}>
											{application.data.scoring_log.guarantor_additional_income} JOD
										</div>
									</div>
								)}
								<div className={styles.item}>
									<div className={styles.key}>Client has early settlement loan</div>
									<div className={styles.value}>
										{application.data.scoring_log.client_has_early_settlement_loan}
									</div>
								</div>
							</div>
						</div>
						<div className={styles.creditDataBox}>
							<div className={styles.title}>Manual stop factors</div>
							<div className={styles.table}>
								{rowStopFactor({
									title: 'Prohibited loan purpose',
									value: application.data.scoring_log.loan_purpose ? 'Yes' : 'No',
									status: application.manual_factors?.loan_purpose,
								})}
								{rowStopFactor({
									title: 'Age',
									value: `${application.data.scoring_log.age} y/o`,
									status: application.manual_factors?.age,
								})}
								{rowStopFactor({
									title: 'Dual loans',
									value: application.data.scoring_log.dual_loans ? 'Yes' : 'No',
									status: application.manual_factors?.dual_loans,
								})}
								{rowStopFactor({
									title: 'Longest payment delay by client (in days)',
									value: application.data.scoring_log.max_days_late_payments,
									status: application.manual_factors?.max_days_late_payments,
								})}
								{rowStopFactor({
									title: 'Client is already a guarantor for another active loan?',
									value: application.data.scoring_log.client_status_gurantor ? 'Yes' : 'No',
									status: application.manual_factors?.client_status_gurantor,
								})}
								{rowStopFactor({
									title: 'Family members delinquent (in the same house)',
									value: application.data.scoring_log.family_members_delinquent ? 'Yes' : 'No',
									status: application.manual_factors?.family_members_delinquent,
								})}
								{rowStopFactor({
									title: 'Active loan with same family ID',
									value:
										application.data.scoring_log.active_loan_with_same_family_id ??
										application.data.scoring_log.current_application_with_same_family_id,
									status:
										application.manual_factors?.active_loan_with_same_family_id ??
										application.manual_factors?.current_application_with_same_family_id,
								})}
								{rowStopFactor({
									title: 'Additional income',
									value: `${application.data.scoring_log.additional_income} JOD`,
									status: application.manual_factors?.additional_income,
								})}
								{rowStopFactor({
									title: 'Client DBR',
									value: `${(application.data.scoring_log.client_dbr * 100).toFixed(1)} %`,
									status: application.manual_factors?.client_dbr,
								})}
								{application.data.scoring_log.legal_case !== null &&
									rowStopFactor({
										title: 'Risky legal case',
										value: application.data.scoring_log.legal_case ? 'Yes' : 'No',
										status: application.manual_factors?.legal_case,
									})}
								{application.data.scoring_log.legal_case_date !== null &&
									rowStopFactor({
										title: 'Legal case date',
										value: application.data.scoring_log.legal_case_date,
										status: application.manual_factors?.legal_case_date,
									})}
								{application.data.scoring_log.date_of_early_settlements_loan !== null &&
									rowStopFactor({
										title: 'Date of early settlement loan',
										value: application.data.scoring_log.date_of_early_settlements_loan,
										status: application.manual_factors?.date_of_early_settlements_loan,
									})}
								{application.data.scoring_log.longest_payment_delay_by_guarantor !== null &&
									rowStopFactor({
										title: 'Longest payment delay by guarantor',
										value: application.data.scoring_log.longest_payment_delay_by_guarantor,
										status: application.manual_factors?.longest_payment_delay_by_guarantor,
									})}
								{rowStopFactor({
									title: 'Nationality',
									value: application.data.scoring_log.nationality,
									status: application.manual_factors?.nationality,
								})}
								{application.guarantor_factors?.map((e, i) => (
									<>
										<div key={i} className={styles.guarantor__title}>
											{`Guarantor #${i + 1}`}{' '}
											<span
												className={
													e.is_approved === 'approved' || e.is_approved === null
														? styles.green
														: e.is_approved === 'review'
														? styles.yellow
														: styles.red
												}
											>
												{stopFactorStatusTranscript(e.is_approved)}
											</span>
										</div>
										{rowStopFactor({
											title: 'Guarantor age',
											value: application.data?.guarantor_log[i].guarantor_age,
											status: e.guarantor_age,
										})}
										{rowStopFactor({
											title: 'Guarantor is already a guarantor for another active loan?',
											value: application.data?.guarantor_log[i].guarantor_for_another_loan
												? 'Yes'
												: 'No',
											status: e.guarantor_for_another_loan,
										})}
										{rowStopFactor({
											title: 'Guarantor has active AMC loan?',
											value: application.data?.guarantor_log[i].guarantor_has_active_loan
												? 'Yes'
												: 'No',
											status: e.guarantor_has_active_loan,
										})}
										{rowStopFactor({
											title: 'Guarantor additional income',
											value: application.data?.guarantor_log[i].guarantor_additional_income,
											status: e.guarantor_additional_income,
										})}
										{rowStopFactor({
											title: 'Longest payment delay by guarantor (in days)',
											value: application.data?.guarantor_log[i].longest_payment_delay_by_guarantor,
											status: e.longest_payment_delay_by_guarantor,
										})}
										{rowStopFactor({
											title: 'Guarantor nationality',
											value: application.data?.guarantor_log[i].guarantor_nationality,
											status: e.guarantor_nationality,
										})}
										{rowStopFactor({
											title: 'Guarantor income',
											value: application.data?.guarantor_log[i].guarantor_income,
											status: 'no_status',
										})}
										{rowStopFactor({
											title: 'Guarantor monthly payment for active loans (non-AMC)',
											value: application.data?.guarantor_log[i].guarantor_total_monthly_payments,
											status: 'no_status',
										})}
										{rowStopFactor({
											title: 'Guarantor DBR',
											value: `${
												application.data?.guarantor_log[i].guarantor_dbr != null
													? (application.data.guarantor_log[i].guarantor_dbr * 100).toFixed(2)
													: '-'
											} %`,
											status: e.guarantor_dbr,
										})}
									</>
								))}
							</div>
						</div>
					</>
				)}
				{!application.data?.scoring_log?.is_approved && (
					<>
						<div className={styles.fieldGroup}>
							<div className={styles.fieldTitle}>Client data</div>
							<div className={styles.fieldList}>
								<Input
									title="Branch"
									id="branch"
									value={form.branch.key}
									hasFilterText
									type="select"
									options={[
										{
											key: 'bayader',
											value: 'Bayader',
										},
										{
											key: 'zarqa',
											value: 'Zarqa',
										},
										{
											key: 'middle_east',
											value: 'Middle East',
										},
										{
											key: 'irbid',
											value: 'Irbid',
										},
										{
											key: 'swaileh',
											value: 'Swaileh',
										},
										{
											key: 'zarqa_jadeedeh',
											value: 'Zarqa Jadeedeh',
										},
										{
											key: 'rsaifeh',
											value: 'Rsaifeh',
										},
										{
											key: 'rsaifeh_(jabal_al_shamali)',
											value: 'Rsaifeh (Jabal Al Shamali)',
										},
										{
											key: 'hashmi',
											value: 'Hashmi',
										},
										{
											key: 'baqaa',
											value: 'Baqaa',
										},
										{
											key: 'marka',
											value: 'Marka',
										},
										{
											key: 'jabal_al_hussien',
											value: 'Jabal Al Hussien',
										},
										{
											key: 'aqaba',
											value: 'Aqaba',
										},
										{
											key: 'irbid-aydoun',
											value: 'Irbid Aydoun',
										},
										{
											key: 'madaba',
											value: 'Madaba',
										},
										{
											key: 'al_karak',
											value: 'Al Karak',
										},
										{
											key: 'ajloun',
											value: 'Ajloun',
										},
										{
											key: 'marj_al_hamam',
											value: 'Marj Al Hamam',
										},
										{
											key: 'abu_nseir',
											value: 'Abu Nseir',
										},
										{
											key: 'hai_nazal',
											value: 'Hai Nazal',
										},
										{
											key: 'al_salt',
											value: 'Al Salt',
										},
										{
											key: 'al_hurria',
											value: 'Al Hurria',
										},
										{
											key: 'jabal_al_naser',
											value: 'Jabal Al Naser',
										},
										{
											key: 'tabarbour',
											value: 'Tabarbour',
										},
										{
											key: 'jarash',
											value: 'Jarash',
										},
										{
											key: 'mota_office',
											value: 'Mota Office',
										},
										{
											key: 'mafraq',
											value: 'Mafraq',
										},
										{
											key: 'dir_allah',
											value: 'Dir Allah',
										},
										{
											key: 'head_office',
											value: 'Head Office',
										},
									].sort((a, b) => (a.value > b.value ? 1 : a.value < b.value ? -1 : 0))}
									onSelect={(option) => handleChangeForm('branch', option)}
								/>
								<Input
									title="Prohibited loan purpose"
									id="loan_purpose"
									value={form.loan_purpose.key}
									type="select"
									infobox={
										<>
											• Facilities required for the purposes of manufacturing or selling weapons or
											related services.
											<br />
											<br />• Facilities required for gambling clubs or any purposes or activities
											related to them.
											<br />
											<br />• Facilities required for the manufacture of cigarettes, tobacco
											products and alcoholic beverages.
											<br />
											<br />• Facilities required for the production of prohibited medical drugs.
											<br />
											<br />• Facilities required to finance political offices.
										</>
									}
									options={[
										{
											key: '1',
											value: 'Yes',
										},
										{
											key: '0',
											value: 'No',
										},
									]}
									onSelect={(option) => handleChangeForm('loan_purpose', option)}
								/>
								<Input
									title="Age"
									value={form.age}
									min={18}
									max={80}
									step={1}
									type="integer"
									onInput={(value) => handleChangeForm('age', value)}
								/>
								<Input
									title="Gender"
									id="gender"
									value={form.gender.key}
									type="select"
									options={[
										{
											key: 'female',
											value: 'Female',
										},
										{
											key: 'male',
											value: 'Male',
										},
									]}
									onSelect={(option) => handleChangeForm('gender', option)}
								/>
								<Input
									title="Family status"
									id="family_status"
									value={form.family_status.key}
									type="select"
									options={[
										{
											key: 'divorced',
											value: 'Divorced',
										},
										{
											key: 'married',
											value: 'Married',
										},
										{
											key: 'single',
											value: 'Single',
										},
										{
											key: 'widowed',
											value: 'Widowed',
										},
									]}
									onSelect={(option) => handleChangeForm('family_status', option)}
								/>
								<Input
									title="Dependants"
									value={form.dependents}
									step={1}
									min={0}
									max={97}
									type="integer"
									onInput={(value) => handleChangeForm('dependents', value)}
								/>
								<Input
									title="Nationality"
									id="nationality"
									value={form.nationality.key}
									type="select"
									hasFilterText
									options={[
										{
											key: 'Jordan',
											value: 'Jordan',
										},
										{
											key: 'Gaza',
											value: 'Gaza',
										},
									]}
									onSelect={(option) => handleChangeForm('nationality', option)}
								/>
								<Input
									title="Address"
									value={form.address}
									type="string"
									onInput={(value) => handleChangeForm('address', value)}
								/>
								<Input
									title="Postponed payments/installments"
									value={form.postpone_payments}
									step={1}
									min={0}
									max={1000000}
									type="float"
									disabled={application.data?.repeated_client === 'new'}
									onInput={(value) => handleChangeForm('postpone_payments', value)}
								/>
								<Input
									title="Dual loans"
									id="dual_loans"
									value={form.dual_loans.key}
									type="select"
									options={[
										{
											key: '1',
											value: 'Yes',
										},
										{
											key: '0',
											value: 'No',
										},
									]}
									onSelect={(option) => handleChangeForm('dual_loans', option)}
								/>
								<Input
									title="Longest payment delay by client (in days)"
									value={form.max_days_late_payments}
									step={1}
									min={0}
									max={1000000}
									type="integer"
									onInput={(value) => handleChangeForm('max_days_late_payments', value)}
								/>
								<Input
									title="Client is already a guarantor for another active loan?"
									id="client_status_gurantor"
									value={form.client_status_gurantor.key}
									type="select"
									options={[
										{
											key: '1',
											value: 'Yes',
										},
										{
											key: '0',
											value: 'No',
										},
									]}
									onSelect={(option) => handleChangeForm('client_status_gurantor', option)}
								/>
								<Input
									title="Family members delinquent (in the same house)"
									id="family_members_delinquent"
									value={form.family_members_delinquent.key}
									type="select"
									options={[
										{
											key: '1',
											value: 'Yes',
										},
										{
											key: '0',
											value: 'No',
										},
									]}
									onSelect={(option) => handleChangeForm('family_members_delinquent', option)}
								/>

								<Input
									title="Active loan with same family ID"
									id="active_loan_with_same_family_id"
									value={form.active_loan_with_same_family_id.key}
									type="select"
									options={[
										{
											key: 'Yes',
											value: 'Yes',
										},
										{
											key: 'No',
											value: 'No',
										},
									]}
									onSelect={(option) => handleChangeForm('active_loan_with_same_family_id', option)}
								/>

								<Input
									title="Project net monthly income"
									value={form.project_net_monthly_income}
									step={1}
									min={0}
									max={1000000}
									type="float"
									onInput={(value) => handleChangeForm('project_net_monthly_income', value)}
								/>
								<Input
									title="Additional income"
									value={form.additional_income}
									step={1}
									min={0}
									max={1000000}
									type="float"
									onInput={(value) => handleChangeForm('additional_income', value)}
								/>
								<Input
									title="Client monthly payment for active loans (non-AMC)"
									value={form.monthly_payment_for_active_loans}
									step={1}
									min={0}
									max={1000000}
									type="float"
									onInput={(value) => handleChangeForm('monthly_payment_for_active_loans', value)}
								/>
								<Input
									title="Client has early settlement loan"
									value={form.client_has_early_settlement_loan.key}
									type="select"
									onSelect={(option) => {
										handleChangeForm('client_has_early_settlement_loan', option);
									}}
									options={[
										{ key: 'Yes', value: 'Yes' },
										{ key: 'No', value: 'No' },
									]}
								/>
								<div className={styles.input}>
									<Input
										title="Date of early settlement loan"
										value={
											form.date_of_early_settlements_loan &&
											new Date(form.date_of_early_settlements_loan.split('/').reverse().join('/'))
										}
										type="date"
										disabled={form.client_has_early_settlement_loan.value === 'No'}
										onSetDate={(value) => {
											handleChangeForm(
												'date_of_early_settlements_loan',
												new Date(value).toLocaleDateString('ru-RU').replaceAll('.', '/')
											);
										}}
									/>
									{form.client_has_early_settlement_loan.value !== 'No' &&
										form.date_of_early_settlements_loan !== '' &&
										form.date_of_early_settlements_loan.length === 10 &&
										isDateNotInFuture(form.date_of_early_settlements_loan) && (
											<div className={styles.error}>
												{isDateNotInFuture(form.date_of_early_settlements_loan)}
											</div>
										)}
								</div>
							</div>
						</div>
						<div className={styles.fieldGroup}>
							<div className={styles.fieldTitle}>Alternative data</div>
							<div className={styles.fieldList}>
								<Input
									title="Client residence"
									id="city"
									value={form.city.key}
									type="select"
									hasFilterText
									options={[
										{
											key: 'al_balqa_governorate',
											value: 'Al Balqa Governorate',
										},
										{
											key: 'capital_governorate',
											value: 'Capital Governorate',
										},
										{
											key: 'zarqa_governorate',
											value: 'Zarqa Governorate',
										},
										{
											key: 'irbid_governorate',
											value: 'Irbid Governorate',
										},
										{
											key: 'aqaba_governorate',
											value: 'Aqaba Governorate',
										},
										{
											key: 'ajloun_governorate',
											value: 'Ajloun Governorate',
										},
										{
											key: 'madaba_governorate',
											value: 'Madaba Governorate',
										},
										{
											key: 'karak_governorate',
											value: 'Karak Governorate',
										},
										{
											key: 'jerash_governorate',
											value: 'Jerash Governorate',
										},
										{
											key: 'mafraq_governorate',
											value: 'Mafraq Governorate',
										},
									].sort((a, b) => (a.value > b.value ? 1 : a.value < b.value ? -1 : 0))}
									onSelect={(option) => handleChangeForm('city', option)}
								/>
								<Input
									title="Residence type"
									id="residence_type"
									value={form.residence_type.key}
									type="select"
									options={[
										{
											key: 'Rent',
											value: 'Rent',
										},
										{
											key: 'Ownership',
											value: 'Ownership',
										},
										{
											key: 'On loan',
											value: 'On loan',
										},
										{
											key: 'Other',
											value: 'Other',
										},
										{
											key: 'None',
											value: 'None',
										},
									]}
									onSelect={(option) => handleChangeForm('residence_type', option)}
								/>
								<Input
									title="Transport"
									id="transport"
									value={form.transport.key}
									type="select"
									options={[
										{
											key: 'Rent',
											value: 'Rent',
										},
										{
											key: 'Ownership',
											value: 'Ownership',
										},
										{
											key: 'On loan',
											value: 'On loan',
										},
										{
											key: 'Other',
											value: 'Other',
										},
										{
											key: 'None',
											value: 'None',
										},
									]}
									onSelect={(option) => handleChangeForm('transport', option)}
								/>
								<Input
									title="Transport manufacturing year"
									value={form.transport_manufacturing_year}
									step={1}
									min={1900}
									max={new Date().getFullYear() + 2}
									type="integer"
									onInput={(value) => handleChangeForm('transport_manufacturing_year', value)}
								/>
								<Input
									title="Employment status"
									id="employment_status"
									value={form.employment_status.key}
									type="select"
									options={[
										{
											key: 'Employed',
											value: 'Employed',
										},
										{
											key: 'Unemployed',
											value: 'Unemployed',
										},
										{
											key: 'Other',
											value: 'Other',
										},
										{
											key: 'None',
											value: 'None',
										},
									]}
									onSelect={(option) => handleChangeForm('employment_status', option)}
								/>
								<Input
									title="Employment level"
									id="employment_level"
									value={form.employment_level.key}
									type="select"
									disabled={
										form.employment_status.key === 'None' ||
										form.employment_status.key === 'Unemployed'
									}
									options={[
										{
											key: 'Government agency',
											value: 'Government agency',
										},
										{
											key: 'Public organization',
											value: 'Public organization',
										},
										{
											key: 'Private company',
											value: 'Private company',
										},
										{
											key: 'Individual entrepreneur',
											value: 'Individual entrepreneur',
										},
										{
											key: 'Other',
											value: 'Other',
										},
										{
											key: 'None',
											value: 'None',
										},
									]}
									onSelect={(option) => handleChangeForm('employment_level', option)}
								/>
								<Input
									title="Work experience"
									value={form.work_experience}
									step={1}
									min={0}
									max={97}
									type="integer"
									disabled={
										form.employment_status.key === 'None' ||
										form.employment_status.key === 'Unemployed'
									}
									onInput={(value) => handleChangeForm('work_experience', value)}
									unit="mon."
								/>
								<Input
									title="Phone OS"
									id="phoneOS"
									value={form.phoneOS.key}
									type="select"
									options={[
										{
											key: 'iOS',
											value: 'IOS',
										},
										{
											key: 'Android',
											value: 'Android',
										},
										{
											key: 'Other',
											value: 'Other',
										},
										{
											key: 'None',
											value: 'None',
										},
									]}
									onSelect={(option) => handleChangeForm('phoneOS', option)}
								/>
							</div>
						</div>

						<div className={styles.fieldGroup}>
							<div className={styles.fieldTitle}>Guarantor data</div>

							{form.guarantors.map((guarantor, index) => (
								<React.Fragment key={index}>
									<p className={styles.guarantorTitle}>Guarantor #{index + 1}</p>
									<div className={styles.fieldList}>
										<Input
											title="Guarantor age"
											value={guarantor.guarantor_age || ''}
											type="integer"
											min={18}
											max={80}
											onInput={(value) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index ? { ...g, guarantor_age: value } : g
													),
												}));
											}}
										/>
										<Input
											title="Guarantor is already a guarantor for another active loan?"
											value={guarantor.guarantor_for_another_loan.key || ''}
											type="select"
											options={[
												{ key: 'true', value: 'Yes' },
												{ key: 'false', value: 'No' },
											]}
											onSelect={(option) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index
															? {
																	...g,
																	guarantor_for_another_loan: {
																		key: option.key,
																		value: option.value,
																	},
															  }
															: g
													),
												}));
											}}
										/>
										<Input
											title="Guarantor has active AMC loan?"
											value={guarantor.guarantor_has_active_loan.key || ''}
											type="select"
											options={[
												{ key: 'true', value: 'Yes' },
												{ key: 'false', value: 'No' },
											]}
											onSelect={(option) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index
															? {
																	...g,
																	guarantor_has_active_loan: {
																		key: option.key,
																		value: option.value,
																	},
															  }
															: g
													),
												}));
											}}
										/>
										<Input
											title="Guarantor income"
											value={guarantor.guarantor_income || ''}
											type="float"
											min={0}
											max={1000000}
											onInput={(value) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index ? { ...g, guarantor_income: value } : g
													),
												}));
											}}
										/>
										<Input
											title="Guarantor additional income"
											value={guarantor.guarantor_additional_income || ''}
											type="float"
											min={0}
											max={1000000}
											onInput={(value) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index ? { ...g, guarantor_additional_income: value } : g
													),
												}));
											}}
										/>

										<Input
											title="Guarantor monthly payment for active loans (non-AMC)"
											value={guarantor.guarantor_total_monthly_payments || ''}
											type="float"
											min={0}
											max={1000000}
											onInput={(value) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index ? { ...g, guarantor_total_monthly_payments: value } : g
													),
												}));
											}}
										/>

										<Input
											title="Longest payment delay by guarantor (in days)"
											value={guarantor.longest_payment_delay_by_guarantor || ''}
											type="integer"
											min={0}
											max={1000000}
											onInput={(value) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index ? { ...g, longest_payment_delay_by_guarantor: value } : g
													),
												}));
											}}
										/>

										<Input
											title="Guarantor nationality"
											value={guarantor.guarantor_nationality.key || ''}
											type="select"
											options={[
												{ key: 'Gaza', value: 'Gaza' },
												{ key: 'Jordan', value: 'Jordan' },
											]}
											onSelect={(option) => {
												setForm((prev) => ({
													...prev,
													guarantors: prev.guarantors.map((g, i) =>
														i === index
															? {
																	...g,
																	guarantor_nationality: { key: option.key, value: option.value },
															  }
															: g
													),
												}));
											}}
										/>
									</div>
								</React.Fragment>
							))}
						</div>
						<div className={styles.footerBox}>
							<div className={styles.buttonGroup}>
								{formValid && (
									<Button pending={pending} onClick={handleCalculate}>
										Calculate
									</Button>
								)}
							</div>
						</div>
					</>
				)}
			</div>
			<div className={styles.result}>
				<ResultBox />
			</div>
		</form>
	);
};

export default Scoring;
